module.exports = __webpack_public_path__ + "static/media/7D.55f5892c.svg";